/*
import {
  hf,
  ht,
  cr,
  gs,
//  usePagez,
  ls,
} from 'lib';
*/
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state

import * as icm from './icm';

import * as Iccv20 from './icvBaseS10Rz';

import * as icv_70S10To from './icv_70S10To';
import * as icv_70S10Co from './icv_70S10Co';

export const N = (pz: {
}) => {

  const _gUserz = gs.useUserz();

  const _lblz = icm.grtLblz({
    tgt: 'メール送信',
  });
  _lblz.btnz.topz.new = `メールの新規送信`;
  _lblz.btnz.cttz.crtz.back = `送信を止める`;
  _lblz.btnz.cttz.crtz.next = `このメールを送信`;
  _lblz.btnz.cttz.dpyz.next = ``;

  const _sPz = ls.usePagez({
    steps: [0],
    phs: 'dpy',
    lblz: _lblz
  });

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _sPz.udtAll,
  });

  return (
    cr.c(Iccv20.N, {
      key: -10,
      cz: {
//        fcyName: '山内地区センター',
        pageName: 
          _sPz.crt.steps[0] == 0 ?
            _sPz.crt.lblz.ttlz.top
          : _sPz.crt.steps[0] == 1 ?
            _sPz.crt.lblz.ttlz.ctt
          : ''
      },
      oClds: [

        _sPz.crt.steps[0] == 0 ?
        cr.c(icv_70S10To.N, {
          key: -10,
          sPz: _sPz,
        })
        : null,

        _sPz.crt.steps[0] == 1 ?
        cr.c(icv_70S10Co.N, {
          key: -20,
          sPz: _sPz,
        })
        : null,

      ]
    })
  );
};
